<template>
  <div>
    <PontotelMenuVertical
      ref="menuVertical"
      :secoes-menu="secoesMenu"
      :secao-acoes-complementares="secaoAcoesComplementares"
      :secoes-rodape="secoesRodape"
      :mostrarIndicadorScroll="mostrarIndicadorScroll"
      :oculto="oculto"
      :logo='logoMenu'
      :aria-labels="traducoesMenu"
      @alterou-estado-expansao="fecharGavetasAbertas"
    />
    <GavetaMinhaConta
      v-if="gavetaMinhaContaAberta"
      :exibirSeletorDePerfil="exibirSeletorDePerfil"
      :perfilAtual="perfilAtual"
      :margem="margemGavetasMenu"
      @fechar="fecharGavetaMinhaConta"
    />
    <Notification
      ref="notificacaoComponente"
      controladoExternamente
      :margem="margemGavetasMenu"
      @update:badgeNotificacoes="atualizarBadgeNotificacoes"
      @update:quantidadeRelatoriosEmAndamento="atualizarQuantidadeRelatoriosEmAndamento"
      @update:visibilidadeNotificacoes="atualizarVisibilidadeNotificacao"
    />
  </div>
</template>

<script>
import { escolherTemaWeb, empresasComWhiteLabel } from '@Lar21/design-tokens'
import { verificarSeEhEmailDeTeste } from 'src/utils/validadoras/validadoras'
import { verificarSeEmpresaUsaCanary } from 'src/utils/executoras/executoras'
import { verificarExistenciaDeSubModulos } from './utilitario'
import { ehUsuarioDeSuporte } from '@/typescript/servicos/usuario/usuarioDeSuporte'
import moment from 'moment'
import { pegarLocalDeTrabalhoPadrao } from 'src/typescript/utils'
import Notification from '../../components/MainHeader/Notification.vue'
import GavetaMinhaConta from './GavetaMinhaConta.vue'
import { dadosEmailSAML } from '../../components/Cognito/dominiosSSO'
import { iniciarTourUserflowManualmente } from 'src/typescript/servicos/userflow/userflow.servico.ts'
import { PontotelMenuVertical } from '@Lar21/imaginii-web-components/lib/vue'
import { abrirWidgetQuickhunt } from 'src/typescript/servicos/quickhunt/quickhunt.servico'
import {
  aplicacaoEstaEmIframe,
  contextoUsaMarcaSankhya,
  obterTemaWhitelabel
} from 'src/typescript/servicos/marca/marcaWhitelabel.servico'

const Daycoval = '61fd1484726c4dacae2ed299'

const iconeChangelog =
  '<svg id="desenhos_contorno" data-name="desenhos contorno" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle fill="currentColor" cx="18.745" cy="11.8203" r="0.4498"/><circle fill="currentColor" cx="9.60101" cy="7.93431" r="0.4498"/><circle fill="currentColor" cx="15.85907" cy="5.81486" r="0.4498"/><circle fill="currentColor" cx="18.52057" cy="8.97148" r="0.4498"/><path fill="currentColor" d="M12.54291,11.16167a.57529.57529,0,0,1,.001-.81739.58918.58918,0,0,1,.81738.001,2.07989,2.07989,0,0,0,2.9414-2.94141L15.24017,8.4644a.57867.57867,0,0,1-.81738.81934,2.13168,2.13168,0,0,0-2.94043-.001,2.07945,2.07945,0,0,0,0,2.94141Z"/><path fill="currentColor" d="M12.86224,8.22709V6.66557a1.53125,1.53125,0,1,0,0-3.0625v1.5625a1.53076,1.53076,0,0,0,0,3.06152Z"/><path fill="currentColor" d="M15.579,12.38627a1.48164,1.48164,0,0,0-1.47949,1.4795h1.459a1.48,1.48,0,1,0,2.96,0h-1.46A1.48164,1.48164,0,0,0,15.579,12.38627Z"/><path fill="currentColor" d="M3.90033,18.19292l2.3584,2.35937,9.123-4.35254L8.25189,9.06889Zm3.48315-3.81849,5.15827,1.51917-3.3291,1.58758-2.90277-.855Zm-1.48632,3.6944,1.28772.37933-.6156.29358Zm5.01172-4.2204-2.8714-.84564.65387-1.3714Z"/></svg>';
const iconeInicio =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M9.77539 9.10257C9.77539 9.45719 9.88055 9.80385 10.0776 10.0987C10.2746 10.3936 10.5546 10.6234 10.8822 10.7591C11.2099 10.8948 11.5704 10.9303 11.9182 10.8611C12.266 10.7919 12.5855 10.6212 12.8362 10.3704C13.087 10.1197 13.2578 9.80018 13.3269 9.45237C13.3961 9.10456 13.3606 8.74405 13.2249 8.41642C13.0892 8.08879 12.8594 7.80876 12.5645 7.61175C12.2697 7.41473 11.923 7.30957 11.5684 7.30957C11.0931 7.31022 10.6374 7.49934 10.3013 7.83545C9.96516 8.17156 9.77604 8.62724 9.77539 9.10257ZM11.8613 9.10257C11.8613 9.16052 11.8441 9.21717 11.812 9.26535C11.7798 9.31354 11.734 9.35109 11.6805 9.37327C11.6269 9.39544 11.568 9.40125 11.5112 9.38994C11.4543 9.37863 11.4021 9.35073 11.3611 9.30975C11.3202 9.26878 11.2923 9.21657 11.281 9.15973C11.2697 9.1029 11.2755 9.04398 11.2976 8.99044C11.3198 8.93691 11.3574 8.89114 11.4055 8.85895C11.4537 8.82675 11.5104 8.80957 11.5683 8.80957C11.646 8.8098 11.7204 8.84074 11.7752 8.89564C11.8301 8.95054 11.8611 9.02494 11.8613 9.10257Z" fill="currentColor"/><path d="M4.50293 8.63184L4.5 18.7618L10.5019 18.7638L10.5039 14.419C10.504 14.2792 10.5316 14.1408 10.5852 14.0117C10.6387 13.8826 10.7172 13.7653 10.8161 13.6665C10.915 13.5677 11.0323 13.4893 11.1615 13.4359C11.2907 13.3825 11.4291 13.355 11.5689 13.3551C11.7087 13.3551 11.8471 13.3827 11.9762 13.4363C12.1053 13.4899 12.2226 13.5683 12.3214 13.6672C12.4202 13.7661 12.4986 13.8835 12.552 14.0126C12.6054 14.1418 12.6329 14.2802 12.6329 14.42L12.6318 18.7648L18.6339 18.7658L18.6367 8.63675L11.5713 3L4.50293 8.63184ZM17.1338 17.2656L14.1318 17.2646L14.1328 14.4199C14.1329 14.0831 14.0666 13.7497 13.9378 13.4385C13.809 13.1273 13.6201 12.8446 13.382 12.6064C13.1439 12.3682 12.8613 12.1793 12.5502 12.0503C12.2391 11.9214 11.9056 11.855 11.5688 11.855C11.2321 11.8549 10.8986 11.9212 10.5874 12.05C10.2763 12.1788 9.99353 12.3676 9.75535 12.6057C9.51718 12.8438 9.32823 13.1265 9.19929 13.4376C9.07035 13.7487 9.00396 14.0821 9.00389 14.4189L9.00189 17.2636L5.99994 17.2616L6.00287 9.35439L11.5712 4.91787L17.1367 9.35928L17.1338 17.2656Z" fill="currentColor"/></svg>';
const iconeCadastro ='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.625 20.6754H18.1011V4.49963H5.625V7.49963H4.5V8.99963H5.625V10.4996H4.5V11.9996H5.625V13.4996H4.5V14.9996H5.625V16.4996H4.5V17.9996H5.625V20.6754ZM7.125 14.9997H8.25V13.4997H7.125V11.9997H8.25V10.4997H7.125V8.99966H8.25V7.49966H7.125V5.99966H16.6011V19.1754H7.125V17.9996H8.25V16.4996H7.125V14.9997Z" fill="currentColor"/></svg>';
const iconeFolha = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 4.50012V20.5314H18.8867V9.17688L14.21 4.50012H6ZM14.6494 7.06067L16.3262 8.73743H14.6494V7.06067ZM7.5 19.0314V6.00012H13.1494V10.2374H17.3867V19.0314H7.5Z" fill="currentColor"/></svg>';
const iconeSolicitacoes = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.397 19.8708L19.0146 17.2527L19.0083 12.3152L16.4829 10.6589L13.8887 10.0446L12.3335 10.3718V4.49976L8.75732 5.17066V12.2302L6.66357 11.2332L4.5 13.4422L10.6084 19.8709L16.397 19.8708ZM6.95361 12.8659L10.1069 14.3689V6.29176L10.9839 6.12676V12.034L13.8829 11.4256L15.8467 11.8563L17.6597 13.0457L17.6641 16.6941L15.8375 18.5213H11.1876L6.37597 13.4558L6.95361 12.8659Z" fill="currentColor"/></svg>';
const iconeRelatoriosImportacoes = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68164 4.49963V12.1724H8.18164V5.99963H13.8311V10.2369H18.0684V13.024H16.6802L15.9844 14.1998L15.2881 13.024H13.8804L15.1763 14.9761L13.8804 16.9683H15.2803L15.9844 15.7603L16.6802 16.9683H18.0684V19.0308H8.18164V17.7506H6.68164V20.5308H19.5684V9.17634L14.8916 4.49963H6.68164ZM15.3311 7.06013L17.0078 8.73689H15.3311V7.06013ZM16.7764 14.9761L18.0684 13.0538V16.9379L16.7764 14.9761Z" fill="currentColor"/><path d="M12.5591 16.0045C12.4489 16.0721 12.3206 16.1041 12.1915 16.0963C11.9874 16.1048 11.7871 16.0392 11.6275 15.9117C11.4975 15.8065 11.3783 15.6888 11.2715 15.5601L10.4551 16.2799C10.5722 16.3954 10.6951 16.5049 10.8232 16.608C10.9921 16.7422 11.1812 16.849 11.3833 16.9244C11.6394 17.0178 11.9106 17.0625 12.1831 17.0562C12.4871 17.0627 12.7889 17.0027 13.0674 16.8804C13.3059 16.7753 13.5106 16.6063 13.6592 16.3922C13.8017 16.1795 13.8757 15.9284 13.8711 15.6724C13.8791 15.4681 13.8292 15.2656 13.7271 15.0884C13.6347 14.9365 13.5073 14.809 13.3555 14.7164C13.2038 14.623 13.0411 14.5489 12.8711 14.4957C12.7007 14.4429 12.5381 14.397 12.3833 14.3599C12.2232 14.3179 12.0977 14.2818 12.0073 14.2525C11.939 14.2346 11.8751 14.203 11.8193 14.1597C11.8031 14.146 11.79 14.129 11.781 14.1098C11.772 14.0906 11.7672 14.0696 11.7671 14.0484C11.7691 14.0139 11.7806 13.9806 11.8005 13.9523C11.8203 13.9241 11.8476 13.9019 11.8794 13.8882C11.9681 13.8419 12.0675 13.8197 12.1675 13.8238C12.3236 13.8245 12.4772 13.8631 12.6152 13.9361C12.7567 14.0087 12.8797 14.1126 12.9751 14.2398L13.7114 13.648C13.5549 13.4173 13.3376 13.2344 13.0835 13.1197C12.8057 12.9946 12.5039 12.9319 12.1992 12.9361C11.7947 12.9163 11.3956 13.0348 11.0674 13.272C10.9303 13.375 10.8198 13.5093 10.7453 13.6638C10.6708 13.8182 10.6344 13.9883 10.6392 14.1597C10.6318 14.3498 10.6776 14.5382 10.7715 14.7037C10.8582 14.8465 10.9756 14.9683 11.1152 15.0601C11.257 15.1539 11.4103 15.2291 11.5713 15.2837C11.7339 15.3404 11.8896 15.3892 12.0391 15.4322C12.1621 15.4644 12.2715 15.4976 12.3672 15.5318C12.4495 15.5596 12.5276 15.5987 12.5991 15.648C12.626 15.6652 12.6482 15.6889 12.6636 15.7169C12.679 15.7449 12.6872 15.7762 12.6875 15.8082C12.6836 15.8488 12.6698 15.8879 12.6475 15.9221C12.6251 15.9563 12.5948 15.9846 12.5591 16.0045Z" fill="currentColor"/><path d="M8.75126 11.3922V15.9684C8.7377 16.1196 8.75714 16.272 8.80823 16.415C8.85932 16.5579 8.94084 16.6881 9.04716 16.7965C9.24877 16.9711 9.50854 17.0638 9.77516 17.0563C9.87845 17.055 9.98147 17.0455 10.0833 17.028C10.2051 17.0073 10.3244 16.9739 10.4393 16.9283V15.9039C10.3963 15.9147 10.3553 15.9244 10.3153 15.9323C10.2744 15.9401 10.2329 15.9441 10.1913 15.944C10.1302 15.9465 10.0699 15.9298 10.0189 15.8961C9.99468 15.8758 9.97582 15.8499 9.96399 15.8206C9.95215 15.7913 9.9477 15.7595 9.95103 15.7281V11.3922H8.75126Z" fill="currentColor"/><path d="M5.70371 16.9687L6.40771 15.7607L7.10271 16.9687H8.51171L7.19971 14.9767L8.51171 13.0237H7.10271L6.40771 14.1997L5.71071 13.0237H4.30371L5.59971 14.9767L4.30371 16.9687H5.70371Z" fill="currentColor"/></svg>';
const iconeFerias = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4746 5.22712C14.5949 4.862 13.6519 4.67382 12.6994 4.67334C11.7469 4.67286 10.8037 4.86008 9.92362 5.2243C9.04354 5.58853 8.24386 6.12261 7.5703 6.79604C6.89673 7.46947 6.36247 8.26903 5.99806 9.14903L5.70997 9.84141L11.7175 12.3323L9.44 17.8256L4.79883 17.8238V19.3238L17.0781 19.3287V17.8287L11.0626 17.8263L13.1024 12.9064L19.1094 15.397L19.3965 14.7037C19.7616 13.824 19.9498 12.8809 19.9503 11.9285C19.9507 10.976 19.7635 10.0328 19.3993 9.1527C19.0351 8.27262 18.501 7.47294 17.8276 6.79937C17.1542 6.12579 16.3546 5.59153 15.4746 5.22712ZM15.2178 8.26712C15.1176 9.48491 14.8428 10.682 14.4018 11.8215L11.5678 10.6466C12.9351 7.70554 14.4987 6.44052 14.9004 6.61283C15.0293 6.6656 15.2764 7.14017 15.2178 8.26712ZM10.4981 6.60994C11.2096 6.3157 11.9731 6.16772 12.743 6.17482C11.6664 7.31335 10.7966 8.63094 10.1728 10.0684L7.71485 9.04937C8.34613 7.94987 9.32529 7.09165 10.4981 6.60994ZM18.2539 13.4185L15.7861 12.3955C16.2912 11.0974 16.6044 9.7327 16.7158 8.34431C16.7257 8.15331 16.7217 7.98561 16.7186 7.81624C17.4494 8.52923 17.977 9.4242 18.2468 10.4089C18.5167 11.3937 18.5192 12.4325 18.2539 13.4185Z" fill="currentColor"/></svg>';
const iconeGestao = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0234 11.3916C18.5501 10.8361 18.8388 10.0967 18.8278 9.33134C18.8169 8.56594 18.5072 7.83513 17.9648 7.29492C17.5084 6.86197 16.9283 6.58228 16.3053 6.49488C15.6823 6.40748 15.0475 6.51672 14.4896 6.80737C14.1366 6.41782 13.7059 6.1065 13.2252 5.89344C12.7446 5.68038 12.2247 5.57031 11.6989 5.57031C11.1732 5.57031 10.6532 5.68038 10.1726 5.89344C9.69197 6.1065 9.26126 6.41782 8.9082 6.80737C8.35025 6.51656 7.71543 6.40723 7.09234 6.49463C6.46926 6.58204 5.88902 6.86182 5.43262 7.29492C4.89024 7.8351 4.58053 8.56591 4.56963 9.33132C4.55872 10.0967 4.84749 10.8361 5.37427 11.3915C4.65918 11.775 4.06104 12.3447 3.6431 13.0402C3.22516 13.7358 3.00296 14.5313 3 15.3428H4.5C4.49863 14.8501 4.61828 14.3647 4.84843 13.9291C5.07859 13.4935 5.4122 13.1211 5.81996 12.8446C6.22772 12.5681 6.69714 12.396 7.18699 12.3434C7.67683 12.2908 8.1721 12.3593 8.62927 12.5428C7.73937 13.0731 7.00224 13.8252 6.48988 14.7256C5.97751 15.6259 5.70745 16.6438 5.70605 17.6797H7.20605C7.20605 16.4881 7.67941 15.3453 8.522 14.5027C9.36458 13.6601 10.5074 13.1868 11.699 13.1868C12.8906 13.1868 14.0334 13.6601 14.8759 14.5027C15.7185 15.3453 16.1919 16.4881 16.1919 17.6797H17.6919C17.6905 16.6437 17.4204 15.6257 16.9079 14.7253C16.3954 13.8249 15.6581 13.0728 14.7681 12.5426C15.2253 12.3591 15.7205 12.2907 16.2104 12.3434C16.7002 12.3961 17.1696 12.5682 17.5773 12.8447C17.985 13.1212 18.3187 13.4936 18.5488 13.9292C18.779 14.3647 18.8987 14.8501 18.8975 15.3428H20.3975C20.3945 14.5314 20.1723 13.7359 19.7544 13.0404C19.3365 12.3449 18.7384 11.7752 18.0234 11.3916ZM16.9043 8.35546C17.1757 8.62693 17.3281 8.99506 17.3281 9.3789C17.3281 9.76275 17.1757 10.1309 16.9043 10.4023C16.6895 10.6057 16.4186 10.7398 16.1266 10.7872C15.8347 10.8347 15.5352 10.7933 15.2671 10.6685C15.5874 9.83859 15.5874 8.91922 15.2671 8.08935C15.5352 7.9645 15.8347 7.92312 16.1266 7.97057C16.4186 8.01802 16.6895 8.15212 16.9043 8.35546ZM11.6987 7.07031C12.1553 7.07022 12.6017 7.20553 12.9814 7.45915C13.3612 7.71276 13.6571 8.07328 13.8319 8.49511C14.0067 8.91694 14.0525 9.38114 13.9635 9.82899C13.8745 10.2768 13.6546 10.6882 13.3318 11.0112C13.009 11.3341 12.5976 11.554 12.1498 11.6431C11.7019 11.7322 11.2377 11.6865 10.8159 11.5118C10.394 11.3371 10.0334 11.0412 9.77972 10.6615C9.52603 10.2819 9.39062 9.83552 9.39062 9.3789C9.39123 8.7669 9.63459 8.18013 10.0673 7.74733C10.5 7.31453 11.0867 7.07105 11.6987 7.07031ZM6.49273 8.35546C6.70778 8.15227 6.97888 8.0183 7.27092 7.9709C7.56296 7.9235 7.86251 7.96485 8.13079 8.08959C7.81059 8.91932 7.81063 9.83852 8.13091 10.6682C7.86273 10.7932 7.56319 10.8346 7.27116 10.7872C6.97913 10.7398 6.70809 10.6057 6.49321 10.4023C6.22192 10.1309 6.06948 9.7628 6.06939 9.379C6.0693 8.99521 6.22156 8.62707 6.49273 8.35546Z" fill="currentColor"/></svg>';
const iconeRegras = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 18.1325C6.00054 18.6296 6.19826 19.1062 6.54977 19.4577C6.90129 19.8092 7.37789 20.0069 7.875 20.0075H18.1953V4.49963H7.83594C7.34918 4.50014 6.88249 4.69374 6.5383 5.03793C6.1941 5.38213 6.00051 5.84881 6 6.33557V18.1325ZM16.6953 18.5075H7.875C7.77554 18.5075 7.68016 18.468 7.60984 18.3976C7.53951 18.3273 7.5 18.2319 7.5 18.1325C7.5 18.033 7.53951 17.9376 7.60984 17.8673C7.68016 17.797 7.77554 17.7575 7.875 17.7575H16.6953V18.5075ZM14.4453 5.99965V8.50746L13.8037 8.02406L13.1621 8.50746V5.99963L14.4453 5.99965ZM7.83594 5.99965H11.6621V11.5172L13.8037 9.90295L15.9453 11.5172V5.99963H16.6953V16.2575H7.875C7.74904 16.2575 7.62341 16.2702 7.5 16.2954V6.33557C7.50008 6.2465 7.53549 6.1611 7.59848 6.09811C7.66146 6.03513 7.74687 5.99973 7.83594 5.99965Z" fill="currentColor"/></svg>';
const iconeAdmin =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M18.012 10.4282L19.2661 9.90923L18.5015 8.06153L17.2316 8.58704C16.721 7.74927 16.0192 7.04443 15.1836 6.53028L15.707 5.26663L13.8594 4.50098L13.3388 5.75782C12.382 5.52671 11.3841 5.52604 10.427 5.75587L9.90722 4.50098L8.05957 5.26663L8.58557 6.5364C7.7477 7.04692 7.0428 7.74882 6.52869 8.5845L5.26514 8.06153L4.50049 9.90919L5.75616 10.4288C5.52537 11.3856 5.52478 12.3835 5.75445 13.3406L4.5 13.8604L5.26562 15.7081L6.53479 15.1822C7.04532 16.0201 7.74712 16.7252 8.5827 17.2396L8.05957 18.502L9.90723 19.2676L10.4278 18.0114C11.3822 18.2513 12.3816 18.2474 13.3341 18.0001L13.8594 19.2676L15.707 18.502L15.1836 17.2389C16.0226 16.7268 16.7292 16.0243 17.2463 15.1883L18.501 15.7081L19.2666 13.8604L18.0108 13.3401C18.2414 12.3832 18.2418 11.3853 18.012 10.4282ZM15.8745 13.4961C15.6643 14.0221 15.3523 14.5015 14.9564 14.9067C14.5605 15.3119 14.0885 15.6349 13.5675 15.8573C13.0465 16.0797 12.4867 16.197 11.9203 16.2026C11.3538 16.2082 10.7918 16.1019 10.2665 15.8898C9.74124 15.6777 9.26299 15.364 8.85919 14.9667C8.4554 14.5694 8.13401 14.0963 7.91346 13.5745C7.69291 13.0527 7.57754 12.4925 7.57395 11.9261C7.57037 11.3596 7.67865 10.798 7.89258 10.2734V10.2724C8.32006 9.21397 9.15051 8.36866 10.2012 7.92249C11.252 7.47631 12.4369 7.46581 13.4954 7.89329C14.5538 8.32077 15.3991 9.15121 15.8453 10.2019C16.2915 11.2527 16.302 12.4376 15.8745 13.4961Z" fill="currentColor"/></svg>';
const iconeIntegracoes =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 8.25H8.25C6.17893 8.25 4.5 9.92893 4.5 12C4.5 14.0711 6.17893 15.75 8.25 15.75H10.5V14.25H8.25C7.00736 14.25 6 13.2426 6 12C6 10.7574 7.00736 9.75 8.25 9.75H10.5V8.25ZM13.5 8.25V9.75H15.75C16.9926 9.75 18 10.7574 18 12C18 13.2426 16.9926 14.25 15.75 14.25H13.5V15.75H15.75C17.8211 15.75 19.5 14.0711 19.5 12C19.5 9.92893 17.8211 8.25 15.75 8.25H13.5ZM8.25 11.25H15.75V12.75H8.25V11.25Z"/></svg>';
const iconeMinhaConta =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M6 17.9479C5.999 17.1868 6.14804 16.433 6.43861 15.7295C6.72918 15.0261 7.15556 14.3868 7.69339 13.8483C8.23121 13.3097 8.86992 12.8825 9.57298 12.591C10.276 12.2995 11.0297 12.1495 11.7908 12.1495C12.5519 12.1495 13.3055 12.2995 14.0086 12.591C14.7116 12.8825 15.3503 13.3097 15.8882 13.8483C16.426 14.3868 16.8524 15.0261 17.1429 15.7295C17.4335 16.433 17.5826 17.1868 17.5816 17.9479H19.0816C19.0797 16.5013 18.6481 15.0878 17.8415 13.8869C17.0348 12.6861 15.8895 11.752 14.551 11.2032C15.3125 10.6252 15.8733 9.8228 16.1544 8.90907C16.4355 7.99533 16.4227 7.01641 16.1178 6.11035C15.8129 5.20428 15.2312 4.41679 14.4549 3.85893C13.6785 3.30107 12.7467 3.00098 11.7907 3.00098C10.8347 3.00098 9.90278 3.30107 9.12643 3.85893C8.35008 4.41679 7.76843 5.20428 7.46351 6.11035C7.15858 7.01641 7.14576 7.99533 7.42687 8.90907C7.70797 9.8228 8.2688 10.6252 9.03028 11.2032C7.69182 11.752 6.54661 12.6861 5.74001 13.887C4.93342 15.0878 4.50182 16.5013 4.5 17.9479H6ZM8.7251 7.59144C8.7251 6.98515 8.90488 6.39248 9.24172 5.88837C9.57855 5.38427 10.0573 4.99136 10.6174 4.75935C11.1776 4.52733 11.7939 4.46663 12.3886 4.58491C12.9832 4.70319 13.5294 4.99514 13.9581 5.42385C14.3868 5.85256 14.6788 6.39876 14.7971 6.9934C14.9153 7.58803 14.8546 8.20439 14.6226 8.76452C14.3906 9.32466 13.9977 9.80341 13.4936 10.1402C12.9895 10.4771 12.3968 10.6569 11.7905 10.6569C10.9778 10.656 10.1986 10.3328 9.6239 9.75806C9.04921 9.18337 8.72597 8.40417 8.7251 7.59144Z" fill="currentColor"/></svg>';
const iconeMinhaEquipe =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.799 16.4742H13.329V15.8452H11.829V16.4742H6.36V19.1822H6V20.6822H8.22V19.1822H7.86V17.9742H11.829V19.1822H11.469V20.6822H13.689V19.1822H13.329V17.9742H17.299V19.1822H16.939V20.6822H19.158V19.1822H18.799V16.4742Z" fill="currentColor"/><path d="M7.58008 14.4613H9.08008C9.08165 13.5342 9.45101 12.6457 10.1071 11.9907C10.7631 11.3358 11.6523 10.9679 12.5793 10.9679C13.5064 10.9679 14.3955 11.3358 15.0516 11.9907C15.7077 12.6457 16.077 13.5342 16.0786 14.4613H17.5786C17.5755 13.5423 17.3184 12.6422 16.8358 11.8602C16.3532 11.0781 15.6639 10.4447 14.8439 10.0299C15.3006 9.58042 15.6133 9.00523 15.742 8.37754C15.8708 7.74984 15.8099 7.09802 15.5671 6.50505C15.3242 5.91208 14.9104 5.40478 14.3784 5.04772C13.8463 4.69066 13.22 4.5 12.5792 4.5C11.9385 4.5 11.3122 4.69066 10.7801 5.04772C10.2481 5.40478 9.83427 5.91208 9.59143 6.50505C9.34859 7.09802 9.28768 7.74984 9.41645 8.37754C9.54523 9.00523 9.85787 9.58042 10.3146 10.0299C9.49467 10.4448 8.80538 11.0782 8.32283 11.8602C7.84028 12.6422 7.58323 13.5424 7.58008 14.4613ZM10.8506 7.73373C10.8505 7.3918 10.9519 7.05753 11.1418 6.7732C11.3318 6.48887 11.6018 6.26726 11.9177 6.13639C12.2336 6.00551 12.5812 5.97126 12.9166 6.03796C13.2519 6.10466 13.56 6.26932 13.8018 6.5111C14.0435 6.75289 14.2082 7.06095 14.2749 7.39631C14.3416 7.73168 14.3073 8.0793 14.1765 8.3952C14.0456 8.71109 13.824 8.98109 13.5396 9.17103C13.2553 9.36097 12.921 9.46232 12.5791 9.46227C12.1208 9.46171 11.6815 9.27941 11.3575 8.95538C11.0334 8.63134 10.8511 8.19199 10.8506 7.73373Z" fill="currentColor"/></svg>';
const iconeAlertas =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M6.00001 10.2012V17.9277H8.63089C8.95363 18.5551 9.44301 19.0814 10.0453 19.4489C10.6475 19.8163 11.3394 20.0107 12.0449 20.0107C12.7505 20.0107 13.4423 19.8163 14.0446 19.4489C14.6469 19.0814 15.1363 18.5551 15.459 17.9277H18.0899V10.2012C18.0916 8.98551 17.7237 7.79805 17.035 6.79626C16.3464 5.79446 15.3695 5.02566 14.2339 4.5918C14.0841 4.12923 13.7915 3.72602 13.3983 3.44003C13.0051 3.15405 12.5314 3 12.0451 3C11.5589 3 11.0852 3.15405 10.692 3.44003C10.2987 3.72602 10.0062 4.12923 9.85643 4.5918C8.72064 5.02545 7.74355 5.79418 7.0548 6.79602C6.36604 7.79785 5.99818 8.98542 6.00001 10.2012ZM12.0449 18.5107C11.4801 18.5079 10.9353 18.3008 10.5112 17.9277H13.5786C13.1545 18.3008 12.6098 18.5079 12.0449 18.5107ZM10.7202 5.87891L11.1997 5.73242L11.2471 5.23342C11.264 5.03351 11.3553 4.84722 11.5029 4.71141C11.6506 4.5756 11.8439 4.50017 12.0445 4.50004C12.2451 4.49992 12.4385 4.57511 12.5863 4.71073C12.7341 4.84636 12.8257 5.03253 12.8428 5.23242L12.8897 5.73242L13.3697 5.87891C14.3002 6.15669 15.1162 6.72738 15.6964 7.50612C16.2766 8.28486 16.59 9.23006 16.5899 10.2012V16.4277H7.50001V10.2012C7.49993 9.23006 7.81329 8.28486 8.39348 7.50612C8.97366 6.72738 9.7897 6.15669 10.7202 5.87891Z" fill="currentColor"/></svg>';
const iconeAcessarBateponto =
  '<svg id="desenhos_contorno" data-name="desenhos contorno" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#fccc31;}.cls-2{fill:#fff;}</style></defs><rect class="cls-1" x="4.5" y="4.5" width="15" height="15"/><path class="cls-2" d="M12.30894,8.42223H10.75461V9.71829H12.3899a1.65968,1.65968,0,1,1,0,3.30458H10.75461V14.319h1.55433a2.96153,2.96153,0,1,0,0-5.89672Z"/><rect class="cls-2" x="8.89201" y="9.71829" width="1.86259" height="1.76709"/><rect class="cls-2" x="8.89201" y="14.31895" width="1.86259" height="1.76709"/></svg>';
const iconeSair =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5508 5.90039V8.58691H13.9512V7.5H5.5V15.9521H13.9512V14.8652H15.5508V17.5518H3.90039V5.90039H15.5508Z" fill="currentColor"/><path d="M19.9541 11.917L17.7637 15.208L16.4307 14.3213L17.292 13.0293L17.5 12.7188H9.9502V11.1182H17.499L17.291 10.8076L16.4316 9.51855L17.7627 8.62988L19.9541 11.917Z" fill="currentColor"/></svg>'

export default {
  name: "MenuLateral",
  components: {
    GavetaMinhaConta,
    Notification,
    PontotelMenuVertical
  },
  props: {
    secaoAcoesComplementares: {
      type: Object,
      default: undefined,
    },
    oculto: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    escolherTemaWeb(obterTemaWhitelabel(this.$store.state, empresasComWhiteLabel))
    this.empresaUsaCanary = await verificarSeEmpresaUsaCanary()
  },
  mounted() {
    // O indicador lateral de scroll do componente desloca os itens e duplica
    // feedback visual. O menu continua rolável por roda/trackpad/teclado.
    this.mostrarIndicadorScroll = false
    window.addEventListener('keydown', this.abrirBuscaDoMenuPorAtalho)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.abrirBuscaDoMenuPorAtalho)
  },
  data() {
    return {
      visibilidadeNotificacao: false,
      visibilidadeChangelog: false,
      gavetaMinhaContaAberta: false,
      totalNotificacoes: 0,
      quantidadeRelatoriosEmAndamento: null,
      mostrarIndicadorScroll: false,
      empresaUsaCanary: false
    }
  },
  computed: {
    ehEmailDeTeste () {
      return verificarSeEhEmailDeTeste(this.$store.state.userInfo.email)
    },
    usuarioEhRH () {
      const tipoPermissao = this.$store.state.userInfo.roleGroup.kind
      return tipoPermissao === 'all'
    },
    rotaFarolDoDP () {
      return 'FarolDoDP'
    },
    estaEmIframe () {
      return aplicacaoEstaEmIframe()
    },
    logoMenu () {
      const idCompman = this.$store.state.userInfo?.compMan.id
      const clienteSankhya = this.$store.state.userInfo?.compMan.isSankhya

      if (contextoUsaMarcaSankhya(this.$store.state)) {
        return require('../../../static/icones/ponto-by-sankhya.png')
      }

      if (clienteSankhya) {
        return require('../../../static/icones/pontotel-sankhya-logo.svg')
      }
      if (empresasComWhiteLabel?.includes(idCompman)) {
        return require(`../../../static/icones/empresa-white-label-logo-${idCompman}.svg`)
      }
      return null
    },
    rotaAtual() {
      return this.$route.name
    },
    idLocalDeTrabalhoPadrao() {
      const { id } = pegarLocalDeTrabalhoPadrao()
      return id
    },
    permissoesEFlags() {
      const sp = {
        showEventlog: this.$store.state.userInfo.compMan.createEventlog,
        hasRecognizeFace: this.$store.state.userInfo.compMan.hasRecognizeFace,
        canUseLocker: this.$store.state.userInfo.compMan.canLockFolha,
        canUseWHB: this.$store.state.userInfo.compMan.hasWhbank,
        hasApprovals: this.$store.state.userInfo.compMan.hasApprovals,
        hasAprovacaoDeArquivos: this.$store.state.userInfo.compMan.hasAprovacaoDeArquivo,
        hasAcompanhamento: this.$store.state.userInfo.compMan?.hasAcompanhamento,
        has671: this.$store.state.userInfo.compMan?.portaria671,
        gestaoDeFerias: this.$store.state.userInfo.compMan?.gestaoDeFerias,
        possuiAprovacaoDeHorasExtras: this.$store.state.userInfo.compMan.possuiAprovacaoDeHorasExtras,
        possuiFarolDoDp: this.$store.state.userInfo.compMan?.possuiFarolDoDp,
        possuiIntegracaoAutomaticaCadastrosSankhya: this.$store.state.userInfo.compMan?.possuiIntegracaoAutomaticaCadastrosSankhya,
        possuiAcessoAuditoriaDeIntegracoes: this.$store.state.modulosEFuncionalidades.funcionalidades.acesso_auditoria_de_integracoes?.enabled === true,
        idEmpresaUsuario: this.$store.state.userInfo.compMan?.id,
        possuiTour: this.$store.state.possuiTour,
        ehSuporte: ehUsuarioDeSuporte(this.$store.state.userInfo)
      }

      const p = {
        cadastros: {
          compemployee: this.$hasPermission({module: 'compemployee', action: 'get'}),
          company: this.$hasPermission({module: 'company', action: 'get'}),
          employer: this.$hasPermission({module: 'employer', action: 'get'}),
          usergroup: this.$hasPermission({module: 'usergroup', action: 'get'}),
          routine: this.$hasPermission({module: 'routine', action: 'get'}),
          holiday: this.$hasPermission({module: 'holidaysCalendar', action: 'get'}),
          biometric: sp.hasRecognizeFace && this.$hasPermission({ module: 'biometric', action: 'get' }),
          dayjourney: this.$hasPermission({module: 'dayjourney', action: 'get'})
        },
        folhas: {
          self: this.$hasPermission({module: 'timelog', action: 'get'}),
          verify: this.$hasPermission({module: 'problems', action: 'get'}),
          autocorrect: this.$hasPermission({module: 'fastregister', action: 'get'}) && this.$hasPermission({
            any: ['justify_post_all', 'justify_post_group', 'suspension_post_all', 'suspension_post_group', 'journey_post_all', 'journey_post_group', 'faketimelog_post_all', 'faketimelog_post_group', 'faketimelog_delete_all', 'faketimelog_delete_group', 'timelog_post_all', 'timelog_post_group']
          }),
          locker: sp.canUseLocker && this.$hasPermission({module: 'locker', action: 'get'})
        },
        solicitacoes: {
          self: sp.hasApprovals && this.$hasPermission({ module: 'objectapprovalsrequest', action: 'get' })
        },
        relatoriosEImportacoes: {
          self: this.$hasPermission({ module: 'exportfiles', action: 'post' })
        },
        ferias: {
          controleDeFerias: sp.gestaoDeFerias,
          calendarioDeFerias: sp.gestaoDeFerias && this.tipoDeUsuarioHabilitado('all', 'group')
        },
        gestao: {
          timemeasurements: this.$hasPermission({module: 'timemeasurements', action: 'get'}),
          realtime: this.$hasPermission({module: 'realtime', action: 'get'}),
          dayjourney: this.$hasPermission({module: 'dayjourney', action: 'get'}),
          escaladoempregado: this.$hasPermission({module: 'escaladoempregado', action: 'get'}),
          acompanhamentoTempoReal: this.$store.state.userInfo.compMan.possuiLimiteHoraExtra && this.$hasPermission({ module: 'acompanhamentodiario', action: 'get' }),
          painelDeSolicitacoesDeHorasExtras: sp.possuiAprovacaoDeHorasExtras && this.tipoDeUsuarioHabilitado('all', 'group'),
          farolDoDP: sp.possuiFarolDoDp && (this.tipoDeUsuarioHabilitado('all') || (
            this.tipoDeUsuarioHabilitado('group') && this.$hasPermission({ module: 'faroldodp', action: 'get' })
          )),
          workhourbankobjects: sp.canUseWHB && this.$hasPermission({ module: 'workhourbankobjects', action: 'get' }),
          aprovacaoarquivo: sp.hasAprovacaoDeArquivos && this.$hasPermission({ module: 'aprovacaoarquivo', action: 'get' })
        },
        admin: {
          user: this.$hasPermission({module: 'user', action: 'get'}),
          appkey: this.$hasPermission({module: 'appkey', action: 'get', filter: ['all']}),
          auditlog: this.$hasPermission({module: 'appkey', action: 'get'}) && this.$store.state.userInfo.compMan.id !== Daycoval,
          dispositivos: this.$store.state.userInfo?.compMan?.portaria1510 === true && this.$hasPermission({ module: 'appkey', action: 'get' }),
          controleDeEstacoes: ['controledeestacoesestacoes', 'controledeestacoesinstalacao', 'controledeestacoesconfiguracao']
            .some(module => this.$hasPermission({ module, action: 'get' })),
          coletores: this.$hasPermission({ module: 'manage', action: 'get' }) && sp.has671,
          layoutE02: this.$hasPermission({ module: 'appkey', action: 'get' }) && sp.ehSuporte,
          parametrizadorE02: (this.$hasPermission({ module: 'appkey', action: 'get' }) && sp.ehSuporte) || this.$hasPermission({ module: 'parametrizadore02', action: 'post' }),
          auditInteg: (this.$hasPermission({ module: 'appkey', action: 'get' }) && sp.ehSuporte) ||
            (this.$hasPermission({ module: 'auditoriadeintegracoes', action: 'get' }) &&
              this.tipoDeUsuarioHabilitado('all') &&
              sp.possuiIntegracaoAutomaticaCadastrosSankhya),
          auditoriaDeIntegracoes: (this.$hasPermission({ module: 'appkey', action: 'get' }) && sp.ehSuporte) ||
            (this.$hasPermission({ module: 'auditoriadeintegracoes', action: 'get' }) &&
              this.tipoDeUsuarioHabilitado('all') &&
              (sp.possuiIntegracaoAutomaticaCadastrosSankhya || sp.possuiAcessoAuditoriaDeIntegracoes)),
          centralAtendimento: this.$hasPermission({module: 'appkey', action: 'get'}) && this.usuarioEhRH,
          tour: sp.possuiTour && !this.ehEmailDeTeste,
          financeiro: this.$store.state.userInfo.email.includes('lar21@') || this.$hasPermission({ module: 'financeiro', action: 'get' })
        },
        regras: {
          customrules: this.$hasPermission({module: 'customrules', action: 'get'}),
          notificationrules: sp.hasAcompanhamento && this.$hasPermission({ module: 'notificationrules', action: 'get' }),
          workhourbankrules: sp.canUseWHB && this.$hasPermission({module: 'workhourbankrules', action: 'get'}),
          ferias: sp.gestaoDeFerias,
          approvalsrules: sp.hasApprovals && this.$hasPermission({module: 'objectapprovalrules', action: 'get'}),
          lockerRules: this.$hasPermission({module: 'appkey', action: 'get', filter: ['all']}) || this.$hasPermission({module: 'regradetravamento', action: 'get'}),
          reason: this.$hasPermission({module: 'reason', action: 'get'}),
          role: this.$hasPermission({module: 'role', action: 'get'})
        }
      }

      return { sp, p }
    },
    secoesMenu() {
      const { sp, p } = this.permissoesEFlags
      const modulos = this.$store.state.modulosEFuncionalidades.modulos
      const funcionalidades = this.$store.state.modulosEFuncionalidades.funcionalidades

      const cadastrosItems = [
        {
          id: "empregados",
          titulo: this.$t('MenuLateral.cadastros.empregados'),
          componentType: 'MenuItem',
          exibir: p.cadastros.compemployee,
          url: this.obterURLRota('employee.list'),
          ativo: this.itemEstaAtivo('employee.list'),
        },
        {
          id: "biometria-facial",
          titulo: this.$t('MenuLateral.cadastros.biometriaFacial'),
          componentType: 'MenuItem',
          exibir: p.cadastros.biometric && (modulos.legado || funcionalidades.medidas_avancadas_antifraude_reconhecimento_facial.enabled),
          url: this.obterURLRota('face-biometric'),
          ativo: this.itemEstaAtivo('face-biometric'),
        },
        {
          id: "feriados",
          titulo: this.$t('MenuLateral.cadastros.feriados'),
          componentType: 'MenuItem',
          exibir: p.cadastros.holiday,
          url: this.obterURLRota('holidays'),
          ativo: this.itemEstaAtivo('holidays'),
        },
        {
          id: "jornadas",
          titulo: this.$t('MenuLateral.cadastros.jornadas'),
          componentType: 'MenuItem',
          exibir: p.cadastros.dayjourney,
          url: this.obterURLRota('workjourney'),
          ativo: this.itemEstaAtivo('workjourney'),
        },
        {
          id: "escalas",
          titulo: this.$t('MenuLateral.cadastros.escalas'),
          componentType: 'MenuItem',
          exibir: p.cadastros.routine,
          url: this.obterURLRota('routine.list'),
          ativo: this.itemEstaAtivo('routine.list'),
        },
        {
          id: "locais-trabalho",
          titulo: this.$t('MenuLateral.cadastros.locaisDeTrabalho'),
          componentType: 'MenuItem',
          exibir: p.cadastros.company,
          url: this.obterURLRota('company.list'),
          ativo: this.itemEstaAtivo('company.list'),
        },
        {
          id: "grupos-de-locais",
          titulo: this.$t('MenuLateral.cadastros.gruposDeLocais'),
          componentType: 'MenuItem',
          exibir: p.cadastros.usergroup,
          url: this.obterURLRota('user-group'),
          ativo: this.itemEstaAtivo('user-group'),
        },
        {
          id: "empregadores",
          titulo: this.$t('MenuLateral.cadastros.empregadores'),
          componentType: 'MenuItem',
          exibir: p.cadastros.employer,
          url: this.obterURLRota('employer.list'),
          ativo: this.itemEstaAtivo('employer.list'),
        },
      ]

      const folhaItems = [
        {
          id: "folha-de-pontos",
          titulo: this.$t('MenuLateral.folha.folhaDePontos'),
          componentType: 'MenuItem',
          exibir: p.folhas.self && (modulos.legado || modulos.registro_de_ponto || modulos.calculos_e_tratamentos),
          url: this.obterUrlTimesheet(this.idLocalDeTrabalhoPadrao),
          ativo: this.itemEstaAtivo('timesheet'),
        },
        {
          id: "verificar-folhas",
          titulo: this.$t('MenuLateral.folha.verificarFolhas'),
          componentType: 'MenuItem',
          exibir: p.folhas.verify && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('verifyTimesheet'),
          ativo: this.itemEstaAtivo('verifyTimesheet'),
        },
        {
          id: "travamento-de-folha",
          titulo: this.$t('MenuLateral.folha.travamentoDeFolha'),
          componentType: 'MenuItem',
          exibir: p.folhas.locker && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('locker-management'),
          ativo: this.itemEstaAtivo('locker-management'),
        },
        {
          id: "alteracoes-em-massa",
          titulo: this.$t('MenuLateral.folha.alteracoesEmMassa'),
          componentType: 'MenuItem',
          exibir: p.folhas.autocorrect && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('mass-changes'),
          ativo: this.itemEstaAtivo('mass-changes'),
        },
      ]

      const feriasItems = [
        {
          id: "controle-de-ferias",
          titulo: this.$t('MenuLateral.ferias.controleDeFerias'),
          componentType: 'MenuItem',
          exibir: p.ferias.controleDeFerias && funcionalidades.acompanhamento_ferias.enabled,
          url: this.obterURLRota('gerenciamentoDeFerias'),
          ativo: this.itemEstaAtivo('gerenciamentoDeFerias'),
        },
        {
          id: "calendario-de-ferias",
          titulo: this.$t('MenuLateral.ferias.calendarioDeFerias'),
          componentType: 'MenuItem',
          exibir: p.ferias.calendarioDeFerias && funcionalidades.acompanhamento_ferias.enabled,
          url: this.obterURLRota('CalendarioDeFerias'),
          ativo: this.itemEstaAtivo('CalendarioDeFerias'),
        },
      ]

      const gestaoItems = [
        {
          id: "calendario-aloque",
          titulo: this.$t('MenuLateral.gestao.calendarioAloque'),
          componentType: 'MenuItem',
          exibir: funcionalidades.acesso_timesheet?.enabled === true,
          url: this.obterURLRota('CalendarioAloque'),
          ativo: this.itemEstaAtivo('CalendarioAloque'),
        },
        {
          id: "acompanhamento-em-tempo-real",
          titulo: this.$t('MenuLateral.gestao.acompanhamentoEmTempoReal'),
          componentType: 'MenuItem',
          exibir: p.gestao.acompanhamentoTempoReal && funcionalidades.acompanhamento_tempo_real.enabled,
          url: this.obterURLRota('acompanhamentoTempoReal'),
          ativo: this.itemEstaAtivo('acompanhamentoTempoReal'),
        },
        {
          id: "banco-de-horas",
          titulo: this.$t('MenuLateral.gestao.bancoDeHoras'),
          componentType: 'MenuItem',
          exibir: (p.gestao.workhourbankobjects && this.mostrarMenuBancoDeHoras()) && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('whb-management'),
          ativo: this.itemEstaAtivo('whb-management'),
        },
        {
          id: "painel-de-acompanhamento",
          titulo: this.$t('MenuLateral.gestao.painelDeAcompanhamento'),
          componentType: 'MenuItem',
          exibir: p.gestao.timemeasurements && (modulos.legado || funcionalidades.painel_acompanhamento_apontamentos_eventos.enabled),
          url: this.obterURLRota('extraTimeDashboard'),
          ativo: this.itemEstaAtivo('extraTimeDashboard'),
        },
        {
          id: "painel-de-pontos",
          titulo: this.$t('MenuLateral.gestao.painelDePontos'),
          componentType: 'MenuItem',
          exibir: sp.ehSuporte && (modulos.legado || modulos.registro_de_ponto),
          url: this.obterURLRota('painelDePontos'),
          ativo: this.itemEstaAtivo('painelDePontos'),
        },
        {
          id: "gestao-de-hora-extra",
          titulo: this.$t('MenuLateral.gestao.gestaoDeHoraExtra'),
          componentType: 'MenuItem',
          exibir: p.gestao.painelDeSolicitacoesDeHorasExtras && funcionalidades.gestao_horas_extras_limite_acompanhamento.enabled,
          url: this.obterURLRota('painelDeSolicitacoesDeHorasExtra'),
          ativo: this.itemEstaAtivo('painelDeSolicitacoesDeHorasExtra'),
        },
        {
          id: "farol-do-dp",
          titulo: this.$t('MenuLateral.gestao.farolDoDP'),
          componentType: 'MenuItem',
          exibir: p.gestao.farolDoDP,
          url: this.obterURLRota(this.rotaFarolDoDP),
          ativo: this.itemEstaAtivo(this.rotaFarolDoDP),
        },
        {
          id: "planejamento-de-escalas",
          titulo: this.$t('MenuLateral.gestao.planejamentoDeEscalas'),
          componentType: 'MenuItem',
          exibir: (p.gestao.dayjourney || p.gestao.escaladoempregado) && (modulos.legado || funcionalidades.planejamento_escalas.enabled),
          url: this.obterURLRota('workSchedule'),
          ativo: this.itemEstaAtivo('workSchedule'),
        },
        {
          id: "gerenciamento-de-arquivos",
          titulo: this.$t('MenuLateral.gestao.gerenciamentoDeArquivos'),
          componentType: 'MenuItem',
          exibir: p.gestao.aprovacaoarquivo && (modulos.legado || modulos.reducao_de_riscos),
          url: this.obterURLRota('fileManagement.list'),
          ativo: this.itemEstaAtivo('fileManagement.list'),
        },
        {
          id: "chat-politicas",
          titulo: this.$t('MenuLateral.gestao.chatPoliticas'),
          componentType: 'MenuItem',
          exibir: funcionalidades.funcionalidade_ia_politica_fechamento.enabled,
          url: this.obterURLRota('chat-politicas'),
          ativo: this.itemEstaAtivo('chat-politicas'),
        },
      ]

      const adminItems = [
        {
          id: "usuarios",
          titulo: this.$t('MenuLateral.admin.usuarios'),
          componentType: 'MenuItem',
          exibir: p.admin.user,
          url: this.obterURLRota('user.edit'),
          ativo: this.itemEstaAtivo('user.edit'),
        },
        {
          id: "faturas-disponiveis",
          titulo: this.$t('MenuLateral.admin.faturasDisponiveis'),
          componentType: 'MenuItem',
          exibir: p.admin.financeiro,
          url: this.obterURLRota('Faturas'),
          ativo: this.itemEstaAtivo('Faturas'),
        },
        {
          id: "central-atendimento",
          titulo: this.$t('MenuLateral.admin.centralAtendimento'),
          componentType: 'MenuItem',
          exibir: p.admin.centralAtendimento,
          url: this.obterURLRota('centralAtendimento'),
          ativo: this.itemEstaAtivo('centralAtendimento'),
        },
        {
          id: "log-de-operacoes",
          titulo: this.$t('MenuLateral.admin.logDeOperacoes'),
          componentType: 'MenuItem',
          exibir: p.admin.auditlog && (sp.ehSuporte || (this.usuarioEhRH && funcionalidades.acesso_auditoria_detalhada?.enabled)),
          url: this.obterURLRota('LogDeOperacoes'),
          ativo: this.itemEstaAtivo('LogDeOperacoes'),
        },
        {
          id: "dados-da-empresa",
          titulo: this.$t('MenuLateral.admin.dadosDaEmpresa'),
          componentType: 'MenuItem',
          exibir: p.admin.appkey,
          url: this.obterURLRota('dados'),
          ativo: this.itemEstaAtivo('dados'),
        },
        // "Conexões MCP" (/conexoes-mcp) fica fora do menu de propósito: é do
        // atendimento, que abre pela URL para ligar o MCP ao próprio agente.
        // A rota e o backend guardam a mesma régua (suporte + appkey).
        {
          id: "coletores",
          titulo: this.$t('MenuLateral.admin.coletores'),
          componentType: 'MenuItem',
          exibir: p.admin.coletores && (modulos.legado || modulos.registro_de_ponto || modulos.reducao_de_riscos),
          url: this.obterURLRota('coletores.listar'),
          ativo: this.itemEstaAtivo('coletores.listar'),
        },
        {
          id: 'dispositivos',
          titulo: this.$t('MenuLateral.admin.dispositivos'),
          componentType: 'MenuItem',
          exibir: p.admin.dispositivos && (modulos.legado || modulos.registro_de_ponto),
          url: this.obterURLRota('devices-management'),
          ativo: this.itemEstaAtivo('devices-management')
        },
        {
          id: 'controle-de-estacoes',
          titulo: this.$t('MenuLateral.admin.controleDeEstacoes'),
          componentType: 'MenuItem',
          exibir: p.admin.controleDeEstacoes && funcionalidades.controle_de_estacoes.enabled,
          url: this.obterURLRota('controle-de-estacoes'),
          ativo: this.itemEstaAtivo('controle-de-estacoes') || this.itemEstaAtivo('controle-de-estacoes.station-detail')
        },
        {
          id: "layout-e02",
          titulo: this.$t('MenuLateral.admin.layoutE02'),
          componentType: 'MenuItem',
          exibir: p.admin.layoutE02 && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('layoutE02'),
          ativo: this.itemEstaAtivo('layoutE02'),
        },
        {
          id: "parametrizador-e02",
          titulo: this.$t('MenuLateral.admin.parametrizadorE02'),
          componentType: 'MenuItem',
          exibir: p.admin.parametrizadorE02 && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('parametrizador.listar'),
          ativo: this.itemEstaAtivo('parametrizador.listar'),
        },
        {
          id: "tour",
          titulo: this.$t('MenuLateral.admin.tour'),
          componentType: 'MenuItem',
          exibir: p.admin.tour,
          acao: () => this.ativarUserFlow(),
          ativo: false,
        },
      ]

      const integracoesItems = [
        {
          id: "configuracao-de-integracoes",
          titulo: this.$t('MenuLateral.integracoes.configuracao'),
          componentType: 'MenuItem',
          exibir: sp.ehSuporte,
          url: this.obterURLRota('SetupDeIntegracoes'),
          ativo: this.itemEstaAtivo('SetupDeIntegracoes'),
        },
        {
          id: "auditoria-de-integracoes",
          titulo: this.$t('MenuLateral.integracoes.auditoria'),
          componentType: 'MenuItem',
          exibir: p.admin.auditoriaDeIntegracoes,
          url: this.obterURLRota('Auditor'),
          ativo: this.itemEstaAtivo('Auditor'),
        },
        {
          id: "integracao-verbas-e-faltas",
          titulo: this.$t('MenuLateral.integracoes.verbasEFaltas'),
          componentType: 'MenuItem',
          exibir: p.admin.auditInteg,
          url: this.obterURLRota('IntegracaoVerbasEFaltas'),
          ativo: this.itemEstaAtivo('IntegracaoVerbasEFaltas'),
        },
      ]

      const regrasItems = [
        {
          id: "calculo",
          titulo: this.$t('MenuLateral.regras.calculo'),
          componentType: 'MenuItem',
          exibir: p.regras.customrules && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('customizacoesDeCalculo.listar'),
          ativo: this.itemEstaAtivo('customizacoesDeCalculo.listar'),
        },
        {
          id: "notificacoes",
          titulo: this.$t('MenuLateral.regras.notificacoes'),
          componentType: 'MenuItem',
          exibir: p.regras.notificationrules && (modulos.legado || modulos.registro_de_ponto || modulos.calculos_e_tratamentos || modulos.controle_custos),
          url: this.obterURLRota('regrasDeNotificacao.listagem'),
          ativo: this.itemEstaAtivo('regrasDeNotificacao.listagem'),
        },
        {
          id: "banco-de-horas",
          titulo: this.$t('MenuLateral.regras.bancoDeHoras'),
          componentType: 'MenuItem',
          exibir: p.regras.workhourbankrules && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('timeoff.list'),
          ativo: this.itemEstaAtivo('timeoff.list'),
        },
        {
          id: "ferias",
          titulo: this.$t('MenuLateral.regras.ferias'),
          componentType: 'MenuItem',
          exibir: p.regras.ferias && funcionalidades.acompanhamento_ferias.enabled,
          url: this.obterURLRota('regrasDeFerias'),
          ativo: this.itemEstaAtivo('regrasDeFerias'),
        },
        {
          id: "solicitacoes",
          titulo: this.$t('MenuLateral.regras.solicitacoes'),
          componentType: 'MenuItem',
          exibir: p.regras.approvalsrules && (modulos.legado || modulos.gestao_participativa || modulos.controle_custos || modulos.gestao_de_ferias_e_ausencias),
          url: this.obterURLRota('approvalRules.list'),
          ativo: this.itemEstaAtivo('approvalRules.list'),
        },
        {
          id: "travamento",
          titulo: this.$t('MenuLateral.regras.travamento'),
          componentType: 'MenuItem',
          exibir: p.regras.lockerRules && (modulos.legado || funcionalidades.governanca_fechamento_travamento_bilateral.enabled),
          url: this.obterURLRota('lockerRules.list'),
          ativo: this.itemEstaAtivo('lockerRules.list'),
        },
        {
          id: "motivos-padrao",
          titulo: this.$t('MenuLateral.regras.motivosPadrao'),
          componentType: 'MenuItem',
          exibir: p.regras.reason && (modulos.legado || modulos.calculos_e_tratamentos),
          url: this.obterURLRota('reason.list'),
          ativo: this.itemEstaAtivo('reason.list'),
        },
        {
          id: "perfil-de-permissao",
          titulo: this.$t('MenuLateral.regras.perfilDePermissao'),
          componentType: 'MenuItem',
          exibir: p.regras.role,
          url: this.obterURLRota('permissions.list'),
          ativo: this.itemEstaAtivo('permissions.list'),
        },
      ]

      return [
        {
          id: "inicio",
          titulo: this.$t('MenuLateral.secoesMenu.inicio'),
          icone: iconeInicio,
          exibir: true,
          url: this.obterURLRota('home'),
          ativo: this.itemEstaAtivo('home'),
        },
        {
          id: "cadastro",
          titulo: this.$t('MenuLateral.secoesMenu.cadastros'),
          icone: iconeCadastro,
          exibir: verificarExistenciaDeSubModulos(cadastrosItems),
          items: cadastrosItems,
        },
        {
          id: "folha",
          titulo: this.$t('MenuLateral.secoesMenu.folha'),
          icone: iconeFolha,
          exibir: verificarExistenciaDeSubModulos(folhaItems),
          items: folhaItems,
        },
        {
          id: "solicitacoes",
          titulo: this.$t('MenuLateral.secoesMenu.solicitacoes'),
          icone: iconeSolicitacoes,
          exibir: p.solicitacoes.self && (modulos.legado || modulos.gestao_participativa || modulos.controle_custos || modulos.gestao_de_ferias_e_ausencias),
          url: this.obterURLRota('approvals'),
          ativo: this.itemEstaAtivo('approvals'),
        },
        {
          id: "relatorios-e-importacoes",
          titulo: this.$t('MenuLateral.secoesMenu.relatoriosEImportacoes'),
          icone: iconeRelatoriosImportacoes,
          exibir: (p.relatoriosEImportacoes.self && !this.possuiPerfisDeAcesso) || this.possuiPerfisDeAcesso && this.perfilSelecionadoNaoEhPessoal,
          url: this.obterURLRota('reports'),
          ativo: this.itemEstaAtivo('reports'),
        },
        {
          id: "ferias",
          titulo: this.$t('MenuLateral.secoesMenu.ferias'),
          icone: iconeFerias,
          exibir: verificarExistenciaDeSubModulos(feriasItems),
          items: feriasItems,
        },
        {
          id: "gestao",
          titulo: this.$t('MenuLateral.secoesMenu.gestao'),
          icone: iconeGestao,
          exibir: verificarExistenciaDeSubModulos(gestaoItems),
          items: gestaoItems,
        },
        {
          id: "admin",
          titulo: this.$t('MenuLateral.secoesMenu.admin'),
          icone: iconeAdmin,
          exibir: verificarExistenciaDeSubModulos(adminItems),
          items: adminItems,
        },
        {
          id: "integracoes",
          titulo: this.$t('MenuLateral.secoesMenu.integracoes'),
          icone: iconeIntegracoes,
          exibir: verificarExistenciaDeSubModulos(integracoesItems),
          items: integracoesItems,
        },
        {
          id: "regras",
          titulo: this.$t('MenuLateral.secoesMenu.regras'),
          icone: iconeRegras,
          exibir: verificarExistenciaDeSubModulos(regrasItems),
          items: regrasItems,
        },
      ];
    },
    secoesRodape() {
      return [
        {
          id: "minha-conta",
          titulo: this.tituloMinhaContaRodape,
          icone: this.iconeMinhaContaRodape,
          componentType: 'MenuItem',
          exibir: true,
          ativo: this.gavetaMinhaContaAberta,
          acao: () => this.alterarEstadoGavetaMinhaConta(),
        },
        {
          id: "alertas",
          titulo: this.tituloAlertasRodape,
          icone: iconeAlertas,
          carregando: !!this.quantidadeRelatoriosEmAndamento,
          exibir: true,
          ativo: this.visibilidadeNotificacao,
          badge: this.badgeAlertas,
          acao: (event) => {
            event.stopPropagation();
            this.gavetaMinhaContaAberta = false;
            if (this.$refs.notificacaoComponente) {
              this.$refs.notificacaoComponente.buscarNotificacoes();
              this.$refs.notificacaoComponente.alterarVisibilidadeDropdown();
            }
          }
        },
        {
          id: "acessarBateponto",
          titulo: this.$t('MenuLateral.secoesRodape.acessarBateponto'),
          componentType: 'MenuItem',
          icone: iconeAcessarBateponto,
          exibir: !this.estaEmIframe && this.possuiEmpregadoAssociado,
          acao: () => this.redirecionarBaterPonto(),
        },
        {
          id: "changelog",
          titulo: this.$t('MenuLateral.secoesRodape.changelog'),
          icone: iconeChangelog,
          exibir: true,
          ativo: this.visibilidadeChangelog,
          fecharMenuAoClicar: false,
          acao: (event) => {
            event.stopPropagation();
            this.abrirWidgetQuickhunt()
          }
        },
        {
          id: "sair",
          titulo: this.$t('MenuLateral.secoesRodape.sair'),
          componentType: 'MenuItem',
          icone: iconeSair,
          exibir: !this.estaEmIframe,
          acao: () => this.sair(),
        },
      ];
    },
    possuiPerfisDeAcesso() {
      return this.$store.state.userInfo.compMan.possuiPerfisDeAcesso
    },
    perfilSelecionadoNaoEhPessoal () {
      return this.$store.state.perfilDeAcessoSelecionadoParaMultiPerfis !== 'pessoal'
    },
    perfilAtual() {
      return this.$store.state.perfilDeAcessoSelecionadoParaMultiPerfis
    },
    badgeAlertas() {
      if (this.totalNotificacoes <= 0) {
        return null
      }

      return {
        conteudo: this.totalNotificacoes.toString(),
        tipo: "erro",
        tamanho: "PP",
        tipoConteudo: "numerico",
      }
    },
    margemGavetasMenu() {
      return this.oculto ? '66px 0 0 0' : '0 0 0 65px'
    },
    tituloAlertasRodape() {
      if (!this.quantidadeRelatoriosEmAndamento) {
        return this.$t('MenuLateral.secoesRodape.alertas')
      }

      return this.$t(
        'MenuLateral.secoesRodape.quantidadeRelatoriosEmAndamento',
        { quantidade: this.quantidadeRelatoriosEmAndamento },
        this.quantidadeRelatoriosEmAndamento
      )
    },
    tituloMinhaContaRodape() {
      if (!this.exibirSeletorDePerfil) {
        return this.$t('MenuLateral.secoesRodape.minhaConta')
      }

      if (this.perfilAtual !== 'gestor') {
        return this.$t('MenuLateral.secoesRodape.minhaConta')
      }

      return this.$t('MenuLateral.secoesRodape.minhaEquipe')
    },
    iconeMinhaContaRodape() {
      if (!this.exibirSeletorDePerfil) {
        return iconeMinhaConta
      }

      if (this.perfilAtual !== 'gestor') {
        return iconeMinhaConta
      }

      return iconeMinhaEquipe
    },
    exibirSeletorDePerfil () {
      const { roleGroup } = this.$store.state.userInfo

      const possuiFlagPermissoesEmpregado = !!this.$store.state.userInfo.grupoPermissoesEmpregado
      const possuiModuloDeDuploPerfilAtivo = !!this.$store.state.userInfo.compMan.possuiPerfisDeAcesso
      const possuiPermissaoGeral = (roleGroup.kind === 'group' || roleGroup.kind === 'all') || (roleGroup.kind === 'mine' && possuiFlagPermissoesEmpregado)
      const possuiPermissaoPessoal = possuiFlagPermissoesEmpregado || roleGroup.kind === 'mine'

      return possuiModuloDeDuploPerfilAtivo && possuiPermissaoGeral && possuiPermissaoPessoal
    },
    possuiEmpregadoAssociado() {
      const compemployee = this.$store.state.userInfo.compemployee
      if(Array.isArray(compemployee) && compemployee.length === 0) {
        return false
      }

      return true
    },
    traducoesMenu() {
      return {
        menuExpandido: this.$t('MenuLateral.acessibilidade.menuExpandido'),
        menuColapsado: this.$t('MenuLateral.acessibilidade.menuColapsado'),
        botaoExpandir: this.$t('MenuLateral.acessibilidade.botaoExpandir'),
        botaoColapsar: this.$t('MenuLateral.acessibilidade.botaoColapsar'),
        scrollTopo: this.$t('MenuLateral.acessibilidade.scrollTopo'),
        scrollFim: this.$t('MenuLateral.acessibilidade.scrollFim'),
        navegacaoPrincipal: this.$t('MenuLateral.acessibilidade.navegacaoPrincipal'),
        placeholderInputBusca: this.$t('MenuLateral.acessibilidade.placeholderInputBusca'),
        legendaTooltipInputBusca: this.$t('MenuLateral.acessibilidade.placeholderInputBusca')
      }
    }
  },
  methods: {
    iniciarTourUserflowManualmente,
    abrirWidgetQuickhunt,
    abrirBuscaDoMenuPorAtalho(event) {
      const teclaK = event.key?.toLowerCase() === 'k'
      const atalhoMac = event.metaKey && teclaK
      const atalhoWindowsOuLinux = event.ctrlKey && teclaK

      if (!atalhoMac && !atalhoWindowsOuLinux) {
        return
      }

      event.preventDefault()
      this.$refs.menuVertical?.abrirMenuEFocarBusca?.()
    },
    redirecionarBaterPonto () {
      const ehAmbienteHomologacao = location.href.includes('hml.pontotel.com.br/pontotel/new-front/')
      const emailUsuario = this.$store.state.userInfo.email || ''
      const possuiPortaria671 = this.$store.state.userInfo.compMan.portaria671
      const [sufixo, dominio] = emailUsuario.toLowerCase().split(/(?=@)/)

      if (ehAmbienteHomologacao) {
        window.open('https://hml.pontotel.com.br/pontotel/bateponto/#/', '_blank')
        return
      }

      const AMBIENTE = 'producao'

      const urlCliente = dadosEmailSAML[dominio]?.urlLoginBatepontoWeb
        ? dadosEmailSAML[dominio].urlLoginBatepontoWeb[AMBIENTE]
        : null

      if (urlCliente && sufixo !== 'lar21') {
        window.open(urlCliente, '_blank')
        return
      }

      if (possuiPortaria671) {
        window.open('https://bateponto.pontotel.com.br/', '_blank')
        return
      }

      window.open('https://registro.pontotel.com.br/', '_blank')
    },
    atualizarBadgeNotificacoes(quantidade) {
      this.totalNotificacoes = quantidade;
    },
    atualizarQuantidadeRelatoriosEmAndamento(quantidadeRelatoriosEmAndamento) {
      this.quantidadeRelatoriosEmAndamento = quantidadeRelatoriosEmAndamento;
    },
    atualizarVisibilidadeNotificacao(visibilidadeNotificacao) {
      this.visibilidadeNotificacao = visibilidadeNotificacao;
    },
    itemEstaAtivo(routeName) {
      if (!routeName) return false

      // Casos especiais para rotas com sub-rotas
      if (this.rotaAtual === 'timesheet') {
        return routeName === 'timesheet'
      }

      if (this.rotaAtual === 'user-group') {
        return routeName === 'user-group'
      }

      if (routeName.includes('.')) {
        const prefix = routeName.split('.')[0]
        return this.rotaAtual && this.rotaAtual.startsWith(prefix)
      }

      return this.rotaAtual === routeName
    },
    obterURLRota(nomeDaRota, parametros = {}) {
      const baseAmbiente = window.location.href.split('#')[0];

      let caminhoResolvido = '';

      // para string direta ('/rota')
      if (typeof nomeDaRota === 'string' && nomeDaRota.startsWith('/')) {
        caminhoResolvido = nomeDaRota;
      } else {
        // para rota do Vue ('home', 'timesheet')
        const rota = this.$router.resolve({ name: nomeDaRota, params: parametros });
        caminhoResolvido = rota.href.replace(/^#/, '');
      }

      const caminhoComBarra = caminhoResolvido.startsWith('/') ? caminhoResolvido : `/${caminhoResolvido}`;

      return `${baseAmbiente}#${caminhoComBarra}`;
    },
    obterUrlTimesheet(idLocalDeTrabalho) {
      if (this.$store.getters.getUserInfo.roles[0].filter === 'mine') {
        const emp = this.$store.state.userInfo.compemployee
        const { closingDate } = emp
        let startDateMine
        let endDateMine

        if (closingDate) {
          if (closingDate === 1) {
            startDateMine = moment().startOf('month').format('YYYY-MM-DD')
            endDateMine = moment().endOf('month').format('YYYY-MM-DD')
          } else {
            startDateMine = moment().date(closingDate).format('YYYY-MM-DD')
            endDateMine = moment().date(closingDate - 1).add(1, 'month').format('YYYY-MM-DD')
          }
        } else {
          startDateMine = moment().startOf('month').format('YYYY-MM-DD')
          endDateMine = moment().endOf('month').format('YYYY-MM-DD')
        }

        return this.obterURLRota('timesheet', {
          type: 'employee',
          startDate: startDateMine,
          endDate: endDateMine,
          id: emp.id
        })
      }
      const today = moment().format('YYYY-MM-DD')

      return this.obterURLRota('timesheet', {
          type: 'work-place',
          startDate: today,
          endDate: today,
          id: idLocalDeTrabalho
        })
    },
    sair() {
      this.$store.dispatch('logout')
    },
    tipoDeUsuarioHabilitado(...tipo) {
      return tipo.includes(this.$store.state.userInfo.roleGroup.kind)
    },
    mostrarMenuBancoDeHoras() {
      const ocultarMenuBancoDeHoras = this.$store.state.userInfo.compMan.frontOptions?.ocultarMenuBancoDeHoras
      const ehFuncionario = this.$store.state.userInfo.roleGroup.kind === 'mine'
      const ehGestor = this.$store.state.userInfo.roleGroup.kind === 'group'

      if (ehGestor && ocultarMenuBancoDeHoras) {
        return false
      }
      if (ehFuncionario) {
        return this.$store.state.userInfo.compMan.frontOptions.mostrarMenuBancoDeHorasParaFuncionario
      }
      return true
    },
    async ativarUserFlow() {
      const idEmpresaUsuario = this.$store.state.userInfo.compMan.id
      const nomeEmpresaUsuario = this.$store.state.userInfo.compMan.name
      const idUsuario = this.$store.state.userInfo.id
      const lastLoginAt = this.$store.state.userInfo.lastLoginAt
      const currentLoginAt = this.$store.state.userInfo.currentLoginAt
      const nomeUsuario = this.$store.state.userInfo.name
      const emailUsuario = this.$store.state.userInfo.email
      const papelUsuario = this.$store.state.userInfo.roleGroup.kind
      const tamanhoEmpresaUsuario = this.$store.state.userInfo.compMan.tamanhoEmpresa
      const canal = this.$store.state.userInfo.compMan.canal
      const modulosDisponiveis = this.$store.state.userInfo.compMan.modulosDisponiveis
      const servicosDisponiveis = this.$store.state.userInfo.compMan.servicosDisponiveis
      const mostrarUserFlow = this.$store.state.userInfo.compMan.mostrarUserFlow
      const ignorarFiltros = true
      await this.$store.dispatch('enviarInformacoesUsuarioUserFlow', { idUsuario, nomeUsuario, emailUsuario, papelUsuario, idEmpresaUsuario, nomeEmpresaUsuario, tamanhoEmpresaUsuario, canal, lastLoginAt, currentLoginAt, modulosDisponiveis, servicosDisponiveis, mostrarUserFlow, ignorarFiltros })
      const TOUR_CHECKLIST_ID = 'f32b5c16-25c5-4d8a-9a7e-ea7460004954'
      iniciarTourUserflowManualmente(TOUR_CHECKLIST_ID)
    },
    fecharGavetasAbertas(evento) {
      const { origem } = evento

      // Caso o menu esteja expandido, e clique no minha conta, ele não "abra e feche"
      if (origem !== 'minha-conta') {
        this.gavetaMinhaContaAberta = false
      }

      if (origem !== 'alertas' && this.visibilidadeNotificacao && this.$refs.notificacaoComponente) {
        this.$refs.notificacaoComponente.fecharGavetaDeRelatorios()
      }
    },
    alterarEstadoGavetaMinhaConta() {
      if (!this.gavetaMinhaContaAberta && this.visibilidadeNotificacao && this.$refs.notificacaoComponente) {
        this.$refs.notificacaoComponente.fecharGavetaDeRelatorios()
      }

      this.gavetaMinhaContaAberta = !this.gavetaMinhaContaAberta
    },
    fecharGavetaMinhaConta() {
      this.gavetaMinhaContaAberta = false
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.pontotel-menu-vertical__cabecalho.menu-expandido > .botao-icone .botao-icone__icone) {
  background-color: currentColor;
  mask: url('~@/../static/icones/icone-fechar.svg') center / contain no-repeat;
}

:deep(.pontotel-menu-vertical__cabecalho.menu-expandido > .botao-icone .botao-icone__icone svg) {
  visibility: hidden;
}

:deep(.menu-secao.menu-secao--selecionado::after) {
  display: none;
}
</style>
